export const SET_SIDER_WIDTH = 'SET_SIDER_WIDTH';
export const RESET_SIDER_WIDTH = 'RESET_SIDER_WIDTH';



// WEBPACK FOOTER //
// ./src/components/page/EnhancedSider/flow/actionTypes.js